export const labelsGaNames = {
  PIM: 'onlineOnly',
  BPR: 'bestPrice',
  LOF: 'offerLimited',
  STD: 'discount',
};

export const isOnlineOnly = (source: string) => source?.toUpperCase() === 'PIM';
